export function getText(value) {
  return (
    value ||
    'I agree to be contacted by the practice for the purposes of scheduling or important communications related to my treatment. This consent is required to proceed. For SMS, message and data rates may apply. Message frequency varies'
  )
}
